(() => {
  const bindMobileFilterClose = async () => {
    if (window.customElements?.whenDefined) {
      await window.customElements.whenDefined('modal-element');
    }

    const modal = document.getElementById('FiltersMobileModal');
    if (!modal) return;

    if (modal.updateComplete) await modal.updateComplete;

    const closeButton = modal.querySelector('[data-close]');
    if (!closeButton || closeButton.dataset.plainJaneCloseBound === 'true') return;

    closeButton.dataset.plainJaneCloseBound = 'true';
    closeButton.addEventListener(
      'click',
      () => {
        modal.open = false;
      },
      { capture: true },
    );

    if (modal.dataset.plainJaneFocusObserverBound === 'true') return;

    modal.dataset.plainJaneFocusObserverBound = 'true';
    const openObserver = new MutationObserver(() => {
      if (modal.hasAttribute('open')) return;

      window.setTimeout(() => {
        const trigger = document.querySelector('.filters__mobile-button');
        if (trigger instanceof HTMLElement) trigger.focus({ preventScroll: true });
      }, 500);
    });

    openObserver.observe(modal, { attributes: true, attributeFilter: ['open'] });
  };

  void bindMobileFilterClose();
  document.addEventListener('section:updated', () => void bindMobileFilterClose());
})();
